import { KSerializerzf77vz1967fq as KSerializer } from '../KSerializer.mjs';
import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_EMPTY_SERIALIZER_ARRAY() {
  _init_properties_PluginHelperInterfaces_kt__xgvzfp();
  return EMPTY_SERIALIZER_ARRAY;
}
var EMPTY_SERIALIZER_ARRAY;
function typeParametersSerializers() {
  return get_EMPTY_SERIALIZER_ARRAY();
}
var GeneratedSerializerClass;
function GeneratedSerializer() {
  if (GeneratedSerializerClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'GeneratedSerializer', VOID, VOID, [KSerializer()]);
    GeneratedSerializerClass = $;
  }
  return GeneratedSerializerClass;
}
var SerializerFactoryClass;
function SerializerFactory() {
  if (SerializerFactoryClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'SerializerFactory');
    SerializerFactoryClass = $;
  }
  return SerializerFactoryClass;
}
var properties_initialized_PluginHelperInterfaces_kt_ap8in1;
function _init_properties_PluginHelperInterfaces_kt__xgvzfp() {
  if (!properties_initialized_PluginHelperInterfaces_kt_ap8in1) {
    properties_initialized_PluginHelperInterfaces_kt_ap8in1 = true;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    EMPTY_SERIALIZER_ARRAY = [];
  }
}
//region block: exports
export {
  get_EMPTY_SERIALIZER_ARRAY as get_EMPTY_SERIALIZER_ARRAY2gyuhuf2kalz,
  typeParametersSerializers as typeParametersSerializers2likxjr48tr7y,
  GeneratedSerializer as GeneratedSerializer1f7t7hssdd2ws,
  SerializerFactory as SerializerFactory1qv9hivitncuv,
};
//endregion

//# sourceMappingURL=PluginHelperInterfaces.mjs.map
